// extracted by mini-css-extract-plugin
export var bar = "Slider-module--bar--5d686";
export var dragging = "Slider-module--dragging--87f09";
export var label = "Slider-module--label--faddb";
export var mark = "Slider-module--mark--be74a";
export var root = "Slider-module--root--79511";
export var thumb = "Slider-module--thumb--8ad33";
export var track = "Slider-module--track--cee81";